import { useNavigate } from 'react-router-dom';
import { CourseFormValues, parseDate, useToast } from '@shared';
import { useMutation, useQuery } from '@tanstack/react-query';
import { coursesApi } from 'App';

type TypeProps = {
  partnerId: string;
  courseId: string;
  rootPath: string;
};

export function useUpdateCourse({ partnerId, courseId, rootPath }: TypeProps) {
  const navigate = useNavigate();
  const toast = useToast();

  const { data, isLoading } = useQuery(
    ['course-by-id', courseId],
    () => coursesApi.get(partnerId, courseId),
    {
      cacheTime: 0,
      select: (data) => {
        const { course: courseAPI } = data;
        return {
          name: courseAPI.name,
          description: courseAPI.description || '',
          start: courseAPI.start && parseDate(courseAPI.start),
          end: courseAPI.end && parseDate(courseAPI.end),
        } as CourseFormValues;
      },
    }
  );
  const { mutate: updateCourse, isLoading: isUpdating } = useMutation({
    mutationFn: (data: CourseFormValues) => coursesApi.updateCourse(partnerId, courseId, data),
    onSuccess: () => {
      toast.success('Course has been updated');
      navigate(rootPath);
    },
  });

  return {
    data,
    isLoading,
    updateCourse,
    isUpdating,
  };
}
